import { Dispatch, MouseEvent, ReactNode, SetStateAction, useState } from 'react';

import { ExitToApp } from '@mui/icons-material';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { Box } from '@mui/system';

import { MenuSystemButton } from 'components/header/menu-system/MenuSystemButton';
import { MenuSystemSessionAlert } from 'components/header/menu-system/MenuSystemSessionAlert';
import { useAuthContext } from 'context/AuthContext';
import { useClientContext } from 'context/ClientContext';

type MenuSystemItem = {
    text: string;
    icon: ReactNode;
    onClick(): void;
};

/**
 * Item do menu de sistema
 */
function MenuSystemItem({ text, icon, onClick }: MenuSystemItem) {
    return (
        <MenuItem
            onClick={onClick}
            sx={{
                '&:first-of-type': { pt: '8px' },
                '&:last-of-type': { pb: '8px' },
                'borderLeft': '3px solid transparent',
                '&:hover': {
                    'borderLeftColor': 'primary.main',
                    'color': 'primary.main',
                    'textShadow': '0 0 0.4px currentColor',
                    '& .MuiListItemIcon-root': { color: 'primary.main' },
                    '& .chevron-icon': { color: 'primary.main' },
                },
            }}
        >
            <ListItemIcon>{icon}</ListItemIcon>

            <ListItemText disableTypography>{text}</ListItemText>
        </MenuItem>
    );
}

/**
 * Menu de sistema completo
 * Contém botão para abrir menu de sistema (ícone) + menu com opções disponiveis
 */
export function MenuSystemDesktop({
    setOpenChangeStoreModal,
    setOpenLogoutConfirm,
}: {
    setOpenChangeStoreModal: Dispatch<SetStateAction<boolean>>;
    setOpenLogoutConfirm: Dispatch<SetStateAction<boolean>>;
}) {
    const { sessionState } = useAuthContext();
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);
    const open = Boolean(anchorEl);
    const { fgAlteraEmpresa } = useClientContext();

    const handleClick = (e: MouseEvent<HTMLButtonElement>): void => setAnchorEl(e.currentTarget as Element);
    const handleClose = (): void => setAnchorEl(null);

    return (
        <>
            <MenuSystemButton onClick={handleClick} />

            <Menu
                anchorEl={anchorEl as Element}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'bottom',
                }}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                    <MenuSystemSessionAlert />

                    {sessionState.status === 'ending' && <Divider />}

                    {fgAlteraEmpresa && (
                        <MenuSystemItem
                            text="Trocar Empresa"
                            icon={<CachedOutlinedIcon fontSize="small" />}
                            onClick={() => setOpenChangeStoreModal(true)}
                        />
                    )}

                    <MenuSystemItem text="Sair" icon={<ExitToApp fontSize="small" />} onClick={() => setOpenLogoutConfirm(true)} />
                </Box>
            </Menu>
        </>
    );
}
